import React, { useState, createContext, useEffect } from "react";
import { Drawer } from "antd";
import useRtc from "@/hooks/use-rtc";
import useQuery from "@/hooks/use-query";
import Participants from "./Participants";
import Header from "./Header";
import Content from "./Content";
import Footer from "./Footer";
import Chat from "@/component/Chat";
import { BoardCommond, RtcType, ShowLayout } from "@/types";
import { METTINGPAGE_SAVED_MEETING_INFO, WSSSERVER } from "@/config/const";
import ee from "@/util/event";

import style from "./style.module.scss";
import { ConferenceInterface } from "@/types";
import { storage } from "@/util";
import { useHistory } from "react-router-dom";

export const MeetingContext = createContext<
  RtcType & { conference?: ConferenceInterface }
>(null);

const Meeting: React.FC = () => {
  const { username, audio, video, speaker, simulcast } = useQuery();
  const [layout, setLayout] = useState<ShowLayout>(ShowLayout.Gallery);
  const [drawerVisible, setDrawerVisible] = useState(true);
  const history = useHistory();

  useEffect(() => {
    console.log(`[Meeting] useEffect username=${username} audio=${audio} video=${video}, speaker=${speaker},simulcast=${simulcast}`)
  }, [])

  const conf: ConferenceInterface = storage.get(
    METTINGPAGE_SAVED_MEETING_INFO
  ) as ConferenceInterface;
  const { userId } = conf;

  const emit = (evt: string, id: string) => {
    if (evt === "removeUser") {
      const uid = id.split("_")[1];
      if (uid === userId) {
        history.go(-1);
      }
    }
  };
  console.log(`useRtc server:${WSSSERVER}`);

  const { participants, service, conference, updateConference, setParticipants } = useRtc(
    {
      server: WSSSERVER,
      roomId: "eNxxUEd1GDqcw6SwMNN3Jy_"+conf.roomId,
      username,
      uid: `eNxxUEd1GDqcw6SwMNN3Jy_${conf.roomId}_${userId}`,
      audio: audio == "true",
      video: video == "true",
      speaker: speaker == "true",
      simulcast: simulcast == "true",
      conf,
      emit,
    }
  );

  const handleLayoutChange = (type: ShowLayout) => {
    if (type !== ShowLayout.Thumbnail) {
      service.pin("", false);
    }
    setLayout(type);
  };

  // React.useEffect(() => {
  //   const haveShared = participants.find((d) => d.share);
  //   const lay =
  //     (haveShared || board.boardShow) && layout === ShowLayout.Gallery
  //       ? ShowLayout.Thumbnail
  //       : layout;
  //   setLayout(lay);
  // }, [board.boardShow, layout, participants]);

  // const realLayout: ShowLayout = React.useMemo(() => {
  //   const haveShared = participants.find((d) => d.share);
  //   const lay =
  //     (haveShared || board.boardShow) && layout === ShowLayout.Gallery
  //       ? ShowLayout.Thumbnail
  //       : layout;
  //   return lay;
  // }, [layout, participants, board]);

  // const [showLayout, setShowLayout] = React.useState<ShowLayout>(
  //   ShowLayout.Gallery
  // );

  // React.useEffect(() => {
  //   if (realLayout === ShowLayout.Thumbnail) {
  //     setShowLayout(ShowLayout.Speaker);
  //     setTimeout(() => {
  //       setShowLayout(ShowLayout.Thumbnail);
  //     }, 200);
  //   } else {
  //     setShowLayout(realLayout);
  //   }
  // }, [realLayout]);

  const footerShareOpen = (v: string) => {
    if (v === "board") {
      service.sendCustomCmdMsg({
        cmdId: BoardCommond.BoardOpen,
        data: {},
      });
      //board.setBoardShow(true);
    }
    if (layout === ShowLayout.Gallery) {
      setLayout(ShowLayout.Side);
    }
  };

  const boardShowHandler = () => {
    setLayout(ShowLayout.Side);
  };

  const shareShowHandler = () => {
     
    console.log(`[Meeting] shareShowHandler`);
    //setLayout(ShowLayout.Speaker);
    setTimeout(() => {
      setLayout(ShowLayout.Speaker);
    }, 400);
  };

  const openVideoHandler = () => {
    const alayout = layout;
    setLayout(ShowLayout.Speaker);
    setTimeout(() => {
      setLayout(alayout);
    }, 200);
  };

  React.useEffect(() => {
    // ee.on("boardshow", boardShowHandler);
    ee.on("openshare", shareShowHandler);
    // ee.on("openVideo", openVideoHandler);
    return () => {
      //ee.off("boardshow", boardShowHandler);
    ee.off("openshare", shareShowHandler);
      //ee.off("openVideo", openVideoHandler);
    };
  }, []);
// 通过上下文获取 conference 主持人信息
  return (
    <MeetingContext.Provider
      value={{ participants, service, conference, updateConference,setParticipants }}
    >
      <div className={style.container}>
        <div
          className={`${style.left} hidden`}
          style={{ paddingRight: drawerVisible ? 320 : 0 }}
        >
          <div className={style.header}>
            <Header layout={layout} onLayoutChange={handleLayoutChange} />
            
          </div>
          <div className={style.content}>
              
              {conference.isHostLeave && <div >Уулзалт үүсгэсэн хүн өрөөнөөс гарсан байна</div>}
             
            <Content layout={layout} />
          </div>
          <div className={style.footer}>
            <Footer
              showParticipants={() => setDrawerVisible(!drawerVisible)}
              open={(v) => footerShareOpen(v)}
            />
          </div>
        </div>
        <Drawer
          className={style.drawer}
          width={320}
          visible={drawerVisible}
          mask={false}
          closable={false}
          // onClose={() => setDrawerVisible(false)}
        >
          <Participants onParticipantsClose={() => setDrawerVisible(false)} />
        </Drawer>
        <Chat />
      </div>
    </MeetingContext.Provider>
  );
};

export default Meeting;
